import { Link } from 'react-router-dom'
import { /* Twitter, */ Linkedin } from 'lucide-react'

function Footer() {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    product: [
      { name: 'Features', href: '/#features' },
      { name: 'How it Works', href: '/#how-it-works' },
      { name: 'Pricing', href: '/pricing', isRoute: true },
    ],
    company: [
      { name: 'About Us', href: '/about', isRoute: true },
      { name: 'Contact Us', href: '/contact', isRoute: true },
      { name: 'Support', href: '/support', isRoute: true },
      { name: 'FAQs', href: '/faqs', isRoute: true },
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy', isRoute: true },
      { name: 'Security & AI Privacy Whitepaper', href: '/security-ai-privacy-whitepaper', isRoute: true },
      { name: 'Terms of Service', href: '/terms', isRoute: true },
    ],
  }

  const socialLinks = [
    // { name: 'Twitter', icon: Twitter, href: 'https://twitter.com/rithmoai' },
    { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com/company/rithmo' },
  ]

  const renderLink = (link) => {
    if (link.isRoute) {
      return (
        <Link
          key={link.name}
          to={link.href}
          className="text-gray-500 hover:text-gray-900 transition-colors"
        >
          {link.name}
        </Link>
      )
    }
    return (
      <a
        key={link.name}
        href={link.href}
        className="text-gray-500 hover:text-gray-900 transition-colors"
        target={link.href.startsWith('http') ? '_blank' : undefined}
        rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
      >
        {link.name}
      </a>
    )
  }

  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-4 lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-12 h-10 flex items-center justify-center">
                <img src="/rithmo-mark.png" alt="Rithmo logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-xl font-bold text-gray-900">Rithmo</span>
            </Link>
            <p className="text-gray-500 mb-6 max-w-sm">
              The AI Chief of Staff for founders and teams who want smarter meetings, deeper visibility, and more time back.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-all"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Product</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.product.map((link) => (
                <li key={link.name}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.company.map((link) => (
                <li key={link.name}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Legal</h3>
            <ul className="space-y-3 text-sm">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-sm text-gray-400 text-center sm:text-left">
            &copy; {currentYear} Rithmo, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
